import { useAuth } from "@clerk/clerk-react";
import axios from "axios";
import { useMemo } from "react";

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Returns an axios instance that injects a Clerk JWT into every request.
 * Use inside components/hooks that already render under <ClerkProvider>.
 *
 * Important: getToken() returns null while Clerk is still loading. Calls made
 * before sign-in will go out unauthenticated, which is fine for endpoints
 * using `optional_user`. Endpoints using `require_user` will respond 401.
 */
export function useApiClient() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const instance = axios.create({ baseURL: API_BASE });
    instance.interceptors.request.use(async (config) => {
      try {
        const token = await getToken();
        if (token) {
          config.headers = config.headers || {};
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch {
        // No token available — let the request go out unauthenticated.
      }
      return config;
    });
    return instance;
  }, [getToken]);
}
